import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Paragraph } from '@agilytics/components';

const Container = styled.div`
  margin: auto;
  text-align: center;
`;

const AnimationContainer = styled.div`
  margin: 20px auto;
  width: 40px;
  height: 40px;
  position: relative;
  transform: rotateZ(45deg);
`;

const foldCubeAngle = keyframes`
  0%, 10% {
    transform: perspective(140px) rotateX(-180deg);
    opacity: 0;
  } 25%, 75% {
    transform: perspective(140px) rotateX(0deg);
    opacity: 1;
  } 90%, 100% {
    transform: perspective(140px) rotateY(180deg);
    opacity: 0;
  }
`;

const Cube = styled.div`
  float: left;
  width: 50%;
  height: 50%;
  position: relative;
  transform: scale(1.2) rotateZ(${({ offset }) => offset * 90}deg);
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.brand};
    animation: ${foldCubeAngle} 2.4s infinite linear both;
    animation-delay: ${({ offset }) => offset * 0.3}s;
    transform-origin: 100% 100%;
  }
`;

export default function Spinner({ text }) {
  return (
    <Container>
      <AnimationContainer>
        <Cube offset={0} />
        <Cube offset={1} />
        <Cube offset={3} />
        <Cube offset={2} />
      </AnimationContainer>
      <Paragraph>{text}</Paragraph>
    </Container>
  );
}
